import { HugeiconsIcon } from "@hugeicons/react";
import { Alert02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";

export const NeedsLockboxBadge = ({ className }: { className?: string }) => (
  <Badge
    variant={BadgeVariant.WARNING}
    size={BadgeSize.SM}
    className={className}
    leftElement={
      <HugeiconsIcon icon={Alert02Icon} size={14} className="shrink-0" />
    }
    tooltip="This unit is available for self-guided showings but has no lockbox linked."
    tooltipClassName="z-[102] !bg-content-1000"
    placement="bottom"
  >
    Needs lockbox
  </Badge>
);
